// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_RELEASES_REQUEST,
  DELETE_RELEASES_REQUEST,
  FETCH_RELEASE_REQUEST,
  UPDATE_RELEASES_REQUEST,
  OPEN_EDIT_RELEASE_PAGE,
} from './actionTypes';
import {
  fetchReleasesSuccess,
  fetchReleasesFailure,
  deleteReleaseSuccess,
  deleteReleaseFailure,
  fetchReleaseSuccess,
  fetchReleaseFailure,
  updateReleaseSuccess,
  updateReleaseFailure,
  openEditReleasePageSuccess,
} from './actions';
import { deleteRelease, getAllReleases, getRelease, updateRelease } from '../../helpers/backend_helper';
import { reduxSerializedError } from '../../utils/utils';

function* fetchReleasesSaga() {
  try {
    const response = yield call(getAllReleases);
    response.sort((a, b) => new Date(b.isAt) - new Date(a.isAt));
    yield put(fetchReleasesSuccess(response));
  } catch (error) {
    yield put(fetchReleasesFailure(reduxSerializedError(error)));
  }
}

function* fetchReleaseSaga({ payload }) {
  try {
    const response = yield call(getRelease, payload);
    yield put(fetchReleaseSuccess(response));
  } catch (error) {
    yield put(fetchReleaseFailure(reduxSerializedError(error)));
  }
}

function* deleteReleasesSaga({ payload }) {
  try {
    yield call(deleteRelease, payload);
    yield put(deleteReleaseSuccess(payload));
    yield call(fetchReleasesSaga); // Refresh the release list
  } catch (error) {
    yield put(deleteReleaseFailure(reduxSerializedError(error)));
  }
}

function* updateReleaseSaga({ payload }) {
  const { release, navigate } = payload;
  try {
    yield call(updateRelease, release);
    navigate(`/releaseNotes`);
    yield put(updateReleaseSuccess());
    yield call(fetchReleasesSaga); // Refresh the release list
  } catch (error) {
    yield put(updateReleaseFailure(reduxSerializedError(error)));
  }
}

function* openEditReleasePageSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/releases/new/${id}`);
    yield put(openEditReleasePageSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_RELEASES_REQUEST, fetchReleasesSaga);
  yield takeEvery(FETCH_RELEASE_REQUEST, fetchReleaseSaga);
  yield takeEvery(UPDATE_RELEASES_REQUEST, updateReleaseSaga);
  yield takeEvery(DELETE_RELEASES_REQUEST, deleteReleasesSaga);
  yield takeEvery(OPEN_EDIT_RELEASE_PAGE, openEditReleasePageSaga);
}
